import { ModalM } from "@common/components/modal/ModalM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useContext } from "react"
import { ScrollView } from "react-native"
import { connect } from "react-redux"
import StudentLiveSessionsList from "./StudentLiveSessionsList"

function StudentLiveSessionsListModal(props) {
    const {
        isOpen,
        handleShowModal,
        handleShowSendTutorMessageModal,
        subscriptionUser,
        navigation,
        sendTutorMessageTutor,
        setSendTutorMessageTutor,
    } = props
    const dimensions = useContext(DimensionsContext)

    return (
        <ModalM
            visible={isOpen}
            onDismiss={handleShowModal}
            style={{
                width: dimensions.width > 800 ? "50%" : "90%",
                maxHeight: "80%",
            }}
        >
            <ScrollView
                style={{
                    marginTop: 10,
                    backgroundColor: theme.colors.white,
                    paddingHorizontal: 20,
                    borderBottomLeftRadius: 10,
                    borderBottomRightRadius: 10,
                }}
                contentContainerStyle={{}}
            >
                <StudentLiveSessionsList
                    student={subscriptionUser}
                    navigation={navigation}
                    handleShowModal={handleShowModal}
                    handleShowSendTutorMessageModal={
                        handleShowSendTutorMessageModal
                    }
                    sendTutorMessageTutor={sendTutorMessageTutor}
                    setSendTutorMessageTutor={setSendTutorMessageTutor}
                    withFillerView
                    noButton
                />
            </ScrollView>
        </ModalM>
    )
}

const mapStateToProps = (state) => {
    return {
        exports: state.data.staticData?.exports,
        exportRequest: state.api?.exportData?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentLiveSessionsListModal)
